module.exports = __webpack_public_path__ + "static/ternumBFC-c83ba5669eed1b162a8bde355549b9fa.png";